import gql from "graphql-tag";

export const UPDATE_ORDER_ITEM = gql`
 mutation ($id: uuid!, $status: String!) {
 update_OrderItems (where: {id: {_eq: $id}}
    _set: {status: $status}) {
    returning {
      id
     }
    } 
  }
`
export const ACCEPT_ORDERITEMS = gql`
mutation accept_orderItems($orderId:uuid!, $lastUpdatedBy:uuid!){
    update_OrderItems(where:{orderId:{_eq:$orderId}},_set:{status:"Sold",lastUpdatedBy:$lastUpdatedBy}){
        returning{id}
    }
}
`
export const REJECT_ORDERITEMS = gql`
mutation reject_orderItems($orderId:uuid!, $lastUpdatedBy:uuid!){
    update_OrderItems(where:{orderId:{_eq:$orderId}},_set:{status:"Rejected",lastUpdatedBy:$lastUpdatedBy}){
        returning{id}
    }
}
`
export const UPDATE_RETAIL_ORDER = gql`
 mutation update_retail_order($orderId: uuid!, $obj: Orders_set_input) {
 update_Orders ( 
     where: {id: {_eq: $orderId}}
     _set: $obj) {
    returning { id }
    } 
  }
`
export const UPDATE_RETAIL_ORDERITEMS = gql`
 mutation update_retail_orderItems($orderItemId: uuid!, $obj: OrderItems_set_input) {
 update_OrderItems ( 
     where: {id: {_eq: $orderItemId}}
     _set: $obj) {
    returning { id }
    } 
  }
`